var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { computed } from "vue";
import { useRouter } from "vue-router/composables";
import { useFileSourceTemplatesStore } from "@/stores/fileSourceTemplatesStore";
import SelectTemplate from "./SelectTemplate.vue";
import CreateInstance from "@/components/ConfigTemplates/CreateInstance.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateUserFileSource',
    setup(__props) {
        const loadingTemplatesInfoMessage = "Loading file source templates";
        const fileSourceTemplatesStore = useFileSourceTemplatesStore();
        fileSourceTemplatesStore.ensureTemplates();
        const templates = computed(() => fileSourceTemplatesStore.latestTemplates);
        const loading = computed(() => fileSourceTemplatesStore.loading);
        const router = useRouter();
        function chooseTemplate(selectTemplateId) {
            return __awaiter(this, void 0, void 0, function* () {
                router.push({
                    path: `/file_source_templates/${selectTemplateId}/new`,
                });
            });
        }
        return { __sfc: true, loadingTemplatesInfoMessage, fileSourceTemplatesStore, templates, loading, router, chooseTemplate, SelectTemplate, CreateInstance };
    }
});
